var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import ReactMarkdown from "react-markdown";
var isAllowedImageSrc = function (src, allowedImageExtensions) {
    if (!src)
        return false;
    if (allowedImageExtensions) {
        if (!/^https?:\/\//i.test(src))
            return false;
        var srcWithoutQuery_1 = src.split(/[?#]/)[0].toLowerCase();
        return allowedImageExtensions.some(function (extension) { return srcWithoutQuery_1.endsWith(".".concat(extension.toLowerCase())); });
    }
    return true;
};
var MdRenderer = function (props) {
    return (_jsx("div", __assign({ style: {
            textAlign: "start",
            width: 'fit-content'
        } }, { children: _jsx(ReactMarkdown, __assign({ remarkPlugins: [remarkGfm], rehypePlugins: [rehypeRaw], components: {
                h1: function (_a) {
                    var children = _a.children;
                    return _jsx(Typography, __assign({ variant: "h4", gutterBottom: true }, { children: children }));
                },
                h2: function (_a) {
                    var children = _a.children;
                    return _jsx(Typography, __assign({ variant: "h5", gutterBottom: true }, { children: children }));
                },
                h3: function (_a) {
                    var children = _a.children;
                    return _jsx(Typography, __assign({ variant: "h6", gutterBottom: true }, { children: children }));
                },
                h4: function (_a) {
                    var children = _a.children;
                    return _jsx(Typography, __assign({ variant: "subtitle1", gutterBottom: true }, { children: children }));
                },
                h5: function (_a) {
                    var children = _a.children;
                    return _jsx(Typography, __assign({ variant: "subtitle2", gutterBottom: true }, { children: children }));
                },
                h6: function (_a) {
                    var children = _a.children;
                    return _jsx(Typography, __assign({ variant: "body1", gutterBottom: true, sx: { fontWeight: 'bold' } }, { children: children }));
                },
                p: function (_a) {
                    var children = _a.children;
                    return _jsx(Typography, __assign({ variant: "body2", paragraph: true }, { children: children }));
                },
                ul: function (_a) {
                    var children = _a.children;
                    return _jsx(Box, __assign({ component: "ul", sx: { pl: 3, mb: 1 } }, { children: children }));
                },
                ol: function (_a) {
                    var children = _a.children;
                    return _jsx(Box, __assign({ component: "ol", sx: { pl: 3, mb: 1 } }, { children: children }));
                },
                li: function (_a) {
                    var children = _a.children;
                    return _jsx(Box, __assign({ component: "li", sx: { mb: 0.5 } }, { children: _jsx(Typography, __assign({ variant: "body2" }, { children: children })) }));
                },
                blockquote: function (_a) {
                    var children = _a.children;
                    return (_jsx(Box, __assign({ component: "blockquote", sx: {
                            borderLeft: '4px solid #e0e0e0',
                            pl: 2,
                            ml: 0,
                            mb: 1,
                            color: 'text.secondary',
                        } }, { children: children })));
                },
                code: function (_a) {
                    var children = _a.children;
                    return (_jsx(Box, __assign({ component: "pre", sx: {
                            backgroundColor: 'action.hover',
                            p: 2,
                            borderRadius: 1,
                            overflow: 'auto',
                            mb: 1,
                        } }, { children: _jsx("code", { children: children }) })));
                },
                table: function (_a) {
                    var children = _a.children;
                    return (_jsx(Box, __assign({ component: "table", sx: {
                            borderCollapse: 'collapse',
                            width: '100%',
                            mb: 1,
                        } }, { children: children })));
                },
                th: function (_a) {
                    var children = _a.children;
                    return (_jsx(Box, __assign({ component: "th", sx: {
                            border: '1px solid #e0e0e0',
                            p: 1,
                            textAlign: 'left',
                            backgroundColor: 'action.hover',
                            fontWeight: 'bold',
                        } }, { children: children })));
                },
                td: function (_a) {
                    var children = _a.children;
                    return (_jsx(Box, __assign({ component: "td", sx: {
                            border: '1px solid #e0e0e0',
                            p: 1,
                            textAlign: 'left',
                        } }, { children: children })));
                },
                a: function (_a) {
                    var href = _a.href, children = _a.children;
                    return (_jsx("a", __assign({ href: href, target: "_blank", rel: "noopener noreferrer" }, { children: children })));
                },
                img: function (_a) {
                    var src = _a.src, alt = _a.alt;
                    if (!isAllowedImageSrc(src, props.allowedImageExtensions))
                        return null;
                    return (_jsx(Box, { component: "img", src: src, alt: alt || "", sx: {
                            display: "block",
                            maxWidth: "100%",
                            height: "auto",
                            borderRadius: 1,
                            my: 1,
                        } }));
                }
            } }, { children: props.children })) })));
};
export default MdRenderer;
